var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.2501C11.2503 9.72454 12.3955 8.44212 13.9113 8.26987C15.4271 8.09762 16.8308 9.09039 17.1734 10.577C17.516 12.0636 16.6883 13.5706 15.25 14.0791C14.6504 14.2911 14.2497 14.8581 14.25 15.4941V16.5001",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 19.5C14.0429 19.5 13.875 19.6679 13.875 19.875C13.875 20.0821 14.0429 20.25 14.25 20.25C14.4571 20.25 14.625 20.0821 14.625 19.875C14.625 19.6679 14.4571 19.5 14.25 19.5V19.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.0000021395,
    y1: 0.682869,
    x2: 28.9758,
    y2: 1.76043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00744886,
    stopColor: "#57ADFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E78BD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c4d5e20a0fc66657ada01ddd7d5070db.svg";
export { ForwardRef as ReactComponent };